import * as React from 'react';

import { translate } from '~l10n/client';

import modal from 'ModalController';
import model from 'RoomsModel';
import view from 'ShareRoomView';

class ShareRoomController {
  render(options) {
    modal.render({
      title: translate('Share Room'),
      modalWidth: '436',
      content: React.createElement(view, {
        roomName: options.roomName,
        url: options.url,
        showInfo: options.showInfo,
        regenerateLink: controller.regenerateLink,
      }),
    });
  }

  closePopup() {
    modal.closeModal();
  }

  regenerateLink(roomName) {
    model.shareRoom(roomName, true);
  }
}

let controller = new ShareRoomController();
module.exports = controller;
